import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Link } from '@tanstack/react-router'
import { Calendar, User } from 'lucide-react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

interface SummaryCardProps {
  summary: {
    id: string
    summary_text: string
    week_start_date: string
    week_end_date: string
    generation_type: string
    patient: {
      id: string
      full_name: string
    }
  }
}

export function SummaryCard({ summary }: SummaryCardProps) {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-muted-foreground" />
            <CardTitle className="text-base">
              {format(new Date(summary.week_start_date), "d 'de' MMM", { locale: ptBR })} -{' '}
              {format(new Date(summary.week_end_date), "d 'de' MMM, yyyy", { locale: ptBR })}
            </CardTitle>
          </div>
          <Badge variant="outline">
            {summary.generation_type}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <Link
          to="/patients/$patientId"
          params={{ patientId: summary.patient.id }}
          className="flex items-center gap-1 text-sm font-medium hover:underline mb-2"
        >
          <User className="h-3 w-3" />
          {summary.patient.full_name}
        </Link>
        <p className="text-sm text-muted-foreground line-clamp-3">
          {summary.summary_text}
        </p>
      </CardContent>
    </Card>
  )
}
